// 成功案例相关接口
import request from "@/utils/request.js";

const Successful = {
  /**
   * 获取成功案例分类列表
   * @param params { page, pageSize, startStatus? } 参数对象，将被作为 post 的 data 发送
   * @returns Promise
   */
  getTypeList: async (params) => {
    return await request("post", "/successful/type/list", params);
  },
};

export default Successful;



// WEBPACK FOOTER //
// ./src/api/successful.js